/**
 * Diadim — single product behaviours.
 *
 * - Sticky add-to-cart bar (низ екрана) appears after user scrolls past the hero.
 * - Tabs: click to switch; keep WC native href anchors as fallback.
 * - Sticky cart qty stepper.
 * - Варіації кнопками замість <select> (select лишається прихованим — ним керує WooCommerce).
 * - Кнопки −/+ біля кількості в основній формі.
 */

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		initStickyCart();
		initTabs();
		initStickyQty();
		initVariationPills();
		initQtyStepper();
	});

	function initStickyCart() {
		const bar = document.getElementById('diadim-sticky-cart');
		if (!bar) return;

		// Trigger element: bottom of the product hero section.
		const trigger = document.querySelector('.prod');
		if (!trigger) return;

		let visible = false;
		const onScroll = () => {
			const triggerBottom = trigger.getBoundingClientRect().bottom;
			const atFooter      = window.innerHeight + window.scrollY >= document.body.offsetHeight - 400;
			const shouldShow    = triggerBottom < 0 && !atFooter;
			if (shouldShow !== visible) {
				visible = shouldShow;
				bar.classList.toggle('is-visible', visible);
			}
		};
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();

		// «Обрати варіант» (варіативний товар) — до форми з варіантами, фокус на перший доступний.
		const form = document.querySelector('.prod__info form.variations_form');
		const choose = bar.querySelector('.sticky-cart__btn--choose');
		if (form && choose) {
			form.id = form.id || 'diadim-buy';
			choose.setAttribute('href', '#' + form.id);
			choose.addEventListener('click', (e) => {
				e.preventDefault();
				const top = form.getBoundingClientRect().top + window.scrollY - 140;
				window.scrollTo({ top, behavior: 'smooth' });
				const first = form.querySelector('.variation-pill[tabindex="0"]') || form.querySelector('select');
				if (first) setTimeout(() => first.focus({ preventScroll: true }), 400);
			});
		}
	}

	function initTabs() {
		const tabsRoot = document.querySelector('.prod-tabs');
		if (!tabsRoot) return;

		const buttons = tabsRoot.querySelectorAll('.prod-tab__btn');
		const panels  = tabsRoot.querySelectorAll('.prod-tab__panel');

		// Auto-activate first tab if none active.
		const liItems = tabsRoot.querySelectorAll('.prod-tab');
		if (!tabsRoot.querySelector('.prod-tab.active') && liItems.length) {
			liItems[0].classList.add('active');
			panels[0]?.classList.add('active');
		}

		buttons.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				const targetId = btn.getAttribute('href') || '';
				if (!targetId.startsWith('#')) return;

				liItems.forEach((li) => li.classList.remove('active'));
				panels.forEach((p) => p.classList.remove('active'));

				btn.parentElement.classList.add('active');
				const panel = tabsRoot.querySelector(targetId);
				if (panel) panel.classList.add('active');
			});
		});
	}

	function initStickyQty() {
		document.querySelectorAll('.sticky-cart__qty').forEach((wrap) => {
			const input = wrap.querySelector('input');
			if (!input) return;
			wrap.querySelectorAll('button[data-qty]').forEach((btn) => {
				btn.addEventListener('click', () => {
					const step = parseInt(btn.dataset.qty, 10) || 1;
					const cur = parseInt(input.value, 10) || 1;
					input.value = Math.max(1, cur + step);
				});
			});
		});
	}

	/**
	 * Кожен <select> атрибута → група кнопок (role="radiogroup"). Клік ставить значення в select
	 * і шле change — далі все робить add-to-cart-variation.js (ціна, наявність, фото, кнопка).
	 * Після кожного перерахунку WooCommerce прибирає з select недоступні опції й вимикає
	 * відсутні в наявності — синхронізуємо стан кнопок за подією woocommerce_update_variation_values.
	 */
	function initVariationPills() {
		const $ = window.jQuery;
		document.querySelectorAll('form.variations_form').forEach((form) => {
			const pillSets = [];

			form.querySelectorAll('table.variations select').forEach((select) => {
				const options = Array.from(select.options).filter((o) => o.value !== '');
				if (!options.length) return;

				const labelEl = form.querySelector('label[for="' + select.id + '"]');
				const current = document.createElement('span');
				current.className = 'variation-current';
				if (labelEl) labelEl.after(current);

				const group = document.createElement('div');
				group.className = 'variation-pills';
				group.setAttribute('role', 'radiogroup');
				if (labelEl) {
					labelEl.id = labelEl.id || select.id + '-label';
					group.setAttribute('aria-labelledby', labelEl.id);
				}

				const pills = options.map((opt) => {
					const btn = document.createElement('button');
					btn.type = 'button';
					btn.className = 'variation-pill';
					btn.setAttribute('role', 'radio');
					btn.dataset.value = opt.value;
					btn.textContent = opt.textContent.trim();
					btn.addEventListener('click', () => {
						if (btn.getAttribute('aria-disabled') === 'true') return;
						const next = select.value === opt.value ? '' : opt.value;
						select.value = next;
						if ($) $(select).trigger('change'); else select.dispatchEvent(new Event('change', { bubbles: true }));
						sync();
					});
					btn.addEventListener('keydown', (e) => {
						const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
						if (!(e.key in keys)) return;
						e.preventDefault();
						const enabled = pills.filter((p) => p.getAttribute('aria-disabled') !== 'true');
						const i = enabled.indexOf(btn);
						const target = enabled[(i + keys[e.key] + enabled.length) % enabled.length];
						if (target) { target.focus(); target.click(); }
					});
					group.appendChild(btn);
					return btn;
				});

				select.classList.add('variation-select-hidden');
				select.setAttribute('tabindex', '-1');
				select.setAttribute('aria-hidden', 'true');
				select.after(group);

				function sync() {
					const live = {};
					Array.from(select.options).forEach((o) => { if (o.value) live[o.value] = !o.disabled; });
					let anyChecked = false;
					pills.forEach((btn) => {
						const v = btn.dataset.value;
						const available = live[v] === true;
						const checked = select.value === v;
						anyChecked = anyChecked || checked;
						btn.setAttribute('aria-checked', checked ? 'true' : 'false');
						btn.setAttribute('aria-disabled', available ? 'false' : 'true');
						btn.classList.toggle('is-unavailable', !available);
						btn.tabIndex = -1;
					});
					// Roving tabindex: у групу потрапляємо одним Tab — на вибрану або першу доступну.
					const focusable = pills.find((p) => p.getAttribute('aria-checked') === 'true')
						|| pills.find((p) => p.getAttribute('aria-disabled') !== 'true')
						|| pills[0];
					if (focusable) focusable.tabIndex = 0;
					const sel = select.options[select.selectedIndex];
					current.textContent = anyChecked && sel ? sel.textContent.trim() : '';
				}

				pillSets.push(sync);
				sync();
			});

			if (!pillSets.length) return;
			form.classList.add('has-variation-pills');
			const syncAll = () => pillSets.forEach((fn) => fn());
			if ($) {
				$(form).on('woocommerce_update_variation_values reset_data found_variation', syncAll);
			}
		});
	}

	/** Кнопки −/+ навколо поля кількості в основній формі товару. */
	function initQtyStepper() {
		document.querySelectorAll('.prod__info form.cart .quantity').forEach((wrap) => {
			const input = wrap.querySelector('input.qty');
			if (!input || input.type === 'hidden' || wrap.querySelector('.qty-step')) return;

			const make = (dir, label, text) => {
				const btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'qty-step qty-step--' + (dir > 0 ? 'plus' : 'minus');
				btn.setAttribute('aria-label', label);
				btn.textContent = text;
				btn.addEventListener('click', () => {
					const step = parseFloat(input.step) || 1;
					const min = input.min !== '' ? parseFloat(input.min) : 1;
					const max = input.max !== '' ? parseFloat(input.max) : Infinity;
					const cur = parseFloat(input.value) || min;
					const next = Math.min(max, Math.max(min, cur + dir * step));
					if (next === cur) return;
					input.value = next;
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});
				return btn;
			};

			wrap.insertBefore(make(-1, 'Зменшити кількість', '−'), input);
			wrap.appendChild(make(1, 'Збільшити кількість', '+'));
		});
	}
})();
